import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, Table, Button, Icon, Select, Tabs, InputNumber, notification, Switch } from 'antd';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Highlighter from 'react-highlight-words';
import './FnbAdditionalItemModal.css';

const { Text } = Typography;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'webSettingStore',
    'FnbAdditionalItemStore'
)
@observer
class FnbAdditionalItemModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
        this.props.webSettingStore.getData();
    }

    // ON CHANGE

    optionNameEnglishOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameEnglish(e.target.value);
    }

    optionNameChineseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameChinese(e.target.value);
    }

    optionNameChineseTraditionalOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameChineseTraditional(e.target.value);
    }

    optionNameThaiOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameThai(e.target.value);
    }

    optionNameJapaneseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameJapanese(e.target.value);
    }

    optionNameVietnameseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setOptionNameVietnamese(e.target.value);
    }

    controlTypeOnChange = (value) => {
        this.props.FnbAdditionalItemStore.setControlType(value);
    }

    subItemNameEnglishOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameEnglish(e.target.value);
    }

    subItemNameChineseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameChinese(e.target.value);
    }

    subItemNameChineseTraditionalOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameChineseTraditional(e.target.value);
    }

    subItemNameThaiOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameThai(e.target.value);
    }

    subItemNameJapaneseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameJapanese(e.target.value);
    }

    subItemNameVietnameseOnChange = (e) => {
        this.props.FnbAdditionalItemStore.setSubItemNameVietnamese(e.target.value);
    }

    priceOnChange = (value) => {
        this.props.FnbAdditionalItemStore.setPrice(value);
    }

    maxNumberOnChange = (value) => {
        this.props.FnbAdditionalItemStore.setMaxNumber(value);
    }

    // ON Search

    fnbItemOnSearch = () => {
        this.props.FnbAdditionalItemStore.setItemSearchValue('');
        this.props.FnbAdditionalItemStore.searchItem();
        this.props.FnbAdditionalItemStore.setShowFnbAdditinalItemSearchModal(true);
    }

    // ON CLICK

    createOrUpdateFnbAdditionalItemDetailOnClick = () => {
        this.props.FnbAdditionalItemStore.createOrUpdateFnbAdditionalItemDetail();
    }

    initUpdateFnbAdditionalItemDetailOnClick = (fnbAdditionalItemDetailId) => {
        this.props.FnbAdditionalItemStore.initUpdateFnbAdditionalItemDetail(fnbAdditionalItemDetailId);
    }

    cancelFnbAdditionalItemDetailOnClick = () => {
        this.props.FnbAdditionalItemStore.cancelFnbAdditionalItemDetail();
    }

    deleteFnbAdditionalItemDetailOnClick = (fnbAdditionalItemDetailId) => {
        this.props.FnbAdditionalItemStore.deleteFnbAdditionalItemDetail(fnbAdditionalItemDetailId);
    }

    createOrUpdateFnbAdditionalItemOnClick = () => {
        const { fnbAdditionalItemId } = this.props.FnbAdditionalItemStore;
        if (fnbAdditionalItemId === 0) {
            this.props.FnbAdditionalItemStore.createFnbAdditionalItem().then(isSuccess => {
                if (isSuccess) {
                    notification['success']({
                        message: 'Success',
                        description: 'FnB Additional Item has been successfully created.',
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: 'Error',
                        description: 'Unexpected issue occured. Please contact your administrator.',
                        duration: 3
                    });
                }
            });
        } else {
            this.props.FnbAdditionalItemStore.updateFnbAdditionalItem().then(isSuccess => {
                if (isSuccess) {
                    notification['success']({
                        message: 'Success',
                        description: 'FnB Additional Item has been successfully updated.',
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: 'Error',
                        description: 'Unexpected issue occured. Please contact your administrator.',
                        duration: 3
                    });
                }
            });
        }
    }

    // ON TAB CLICK

    tabOptionNameOnTabClick = (key) => {
        this.props.FnbAdditionalItemStore.setTabOptionNameActiveKey(key);
    }

    tabSubItemNameOnTabClick = (key) => {
        this.props.FnbAdditionalItemStore.setTabSubItemNameActiveKey(key);
    }

    // TABLE SETTING

    getColumns = () => {
        return [
            {
                title: 'Sub Item Name',
                dataIndex: 'subItemName',
                key: 'subItemName',
                ...this.getColumnSearchProps('subItemName')
            },
            {
                title: 'Price',
                dataIndex: 'price',
                key: 'price',
            },
            {
                title: 'Action',
                dataIndex: 'fnbAdditionalItemDetailId',
                key: 'action',
                render: fnbAdditionalItemDetailId => (
                    <span>
                        <Button onClick={() => this.initUpdateFnbAdditionalItemDetailOnClick(fnbAdditionalItemDetailId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteFnbAdditionalItemDetailOnClick(fnbAdditionalItemDetailId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            fnbAdditionalItemDetails,
            fnbTaskName,
            tabOptionNameActiveKey,
            optionNameEnglish,
            optionNameChinese,
            optionNameChineseTraditional,
            optionNameThai,
            optionNameJapanese,
            optionNameVietnamese,
            isRequired,
            controlType,
            maxNumber,
            tabSubItemNameActiveKey,
            subItemNameEnglish,
            subItemNameChinese,
            subItemNameChineseTraditional,
            subItemNameThai,
            subItemNameJapanese,
            subItemNameVietnamese,
            price,
            itemDetailTextButton,
            itemTextButton,
            fnbAdditionalItemModalLoading
        } = this.props.FnbAdditionalItemStore;

        let addOrUpdateItemDetailDisable = false;
        if (subItemNameEnglish === '') {
            addOrUpdateItemDetailDisable = true;
        }

        let addOrUpdateItemDisable = false;
        if (fnbTaskName === '' || optionNameEnglish === '' || fnbAdditionalItemDetails.length === 0) {
            addOrUpdateItemDisable = true;
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Spin spinning={fnbAdditionalItemModalLoading}>
                                <Row className='fnbadditionalitemmodal-row-container'>
                                    <Col span={24} className='fnbadditionalitemmodal-col'>
                                        <Row>
                                            <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                <Text className='fnbadditionalitemmodal-text-label'>FnB Item<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                <Search
                                                    placeholder='search item'
                                                    value={fnbTaskName}
                                                    onSearch={this.fnbItemOnSearch}
                                                    enterButton
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='fnbadditionalitemmodal-col'>
                                        <Row>
                                            <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                <Text className='fnbadditionalitemmodal-text-label'>Control Type<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16}>
                                                <Row>
                                                    <Col span={24} className='fnbadditionalitemmodal-col-input'>
                                                        <Select className='fnbadditionalitemmodal-select' value={controlType} onChange={this.controlTypeOnChange}>
                                                            <Option key='check' value='check'>Multi Check List</Option>
                                                            <Option key='radio' value='radio'>Radio List</Option>
                                                        </Select>
                                                    </Col>
                                                    <Col span={24} className='fnbadditionalitemmodal-col-input-switch'>
                                                        <Switch checkedChildren='Yes' unCheckedChildren='No' checked={isRequired} onChange={(e) => this.props.FnbAdditionalItemStore.setIsRequired(e)} className='fnbadditionalitemmodal-switch-all' />
                                                        <Text className='fnbadditionalitemmodal-text-switch-all'>Compulsary</Text>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <React.Fragment>
                                        {
                                            controlType === 'check'
                                                ?
                                                <Col span={24} className='fnbadditionalitemmodal-col'>
                                                    <Row>
                                                        <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                            <Text className='fnbadditionalitemmodal-text-label'>Maximum Selection<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                                        </Col>
                                                        <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                            <InputNumber
                                                                className='fnbadditionalitemmodal-inputnumber-short'
                                                                min={1}
                                                                value={maxNumber}
                                                                onChange={this.maxNumberOnChange}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                :
                                                null
                                        }
                                    </React.Fragment>
                                    <Col span={24} className='fnbadditionalitemmodal-col'>
                                        <Row>
                                            <Col span={8} className='fnbadditionalitemmodal-col-label-tabs'>
                                                <Text className='fnbadditionalitemmodal-text-label'>Option Name<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                <Tabs activeKey={tabOptionNameActiveKey} onTabClick={this.tabOptionNameOnTabClick}>
                                                    {/* English */}
                                                    {
                                                        this.isLanguageIdActive(1)
                                                            ?
                                                            <TabPane tab='English *' key='1'>
                                                                <Input className='fnbadditionalitemmodal-input' value={optionNameEnglish} onChange={this.optionNameEnglishOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese */}
                                                    {
                                                        this.isLanguageIdActive(2)
                                                            ?
                                                            <TabPane tab='简体中文' key='2'>
                                                                <Input className='fnbadditionalitemmodal-input' value={optionNameChinese} onChange={this.optionNameChineseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Chinese Traditional */}
                                                    {
                                                        this.isLanguageIdActive(3)
                                                            ?
                                                            <TabPane tab='繁體中文' key='3'>
                                                                <Input className='fnbadditionalitemmodal-input' value={optionNameChineseTraditional} onChange={this.optionNameChineseTraditionalOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Thai */}
                                                    {
                                                        this.isLanguageIdActive(4)
                                                            ?
                                                            <TabPane tab='ไทย' key='4'>
                                                                <Input className='fnbadditionalitemmodal-input' value={optionNameThai} onChange={this.optionNameThaiOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Japanese */}
                                                    {
                                                        this.isLanguageIdActive(5)
                                                            ?
                                                            <TabPane tab='日本' key='5'>
                                                                <Input className='fnbadditionalitemmodal-input' value={optionNameJapanese} onChange={this.optionNameJapaneseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }

                                                    {/* Vietnamese */}
                                                    {
                                                        this.isLanguageIdActive(6)
                                                            ?
                                                            <TabPane tab='Vietnamese' key='6'>
                                                                <Input className='fnbadditionalitemmodal-input' value={optionNameVietnamese} onChange={this.optionNameVietnameseOnChange} />
                                                            </TabPane>
                                                            :
                                                            null
                                                    }
                                                </Tabs>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='fnbadditionalitemmodal-col-subitem'>
                                        <Row>
                                            <Col span={24} className='fnbadditionalitemmodal-col-title'>
                                                <Text className='fnbadditionalitemmodal-text-title'>Sub Item List</Text>
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Table columns={this.getColumns()} dataSource={fnbAdditionalItemDetails} />
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Row>
                                                    <Col span={8} className='fnbadditionalitemmodal-col-label-tabs'>
                                                        <Text className='fnbadditionalitemmodal-text-label'>Sub Item Name<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                                    </Col>
                                                    <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                        <Tabs activeKey={tabSubItemNameActiveKey} onTabClick={this.tabSubItemNameOnTabClick}>
                                                            {/* English */}
                                                            {
                                                                this.isLanguageIdActive(1)
                                                                    ?
                                                                    <TabPane tab='English *' key='1'>
                                                                        <Input className='fnbadditionalitemmodal-input' value={subItemNameEnglish} onChange={this.subItemNameEnglishOnChange} />
                                                                    </TabPane>
                                                                    :
                                                                    null
                                                            }

                                                            {/* Chinese */}
                                                            {
                                                                this.isLanguageIdActive(2)
                                                                    ?
                                                                    <TabPane tab='简体中文' key='2'>
                                                                        <Input className='fnbadditionalitemmodal-input' value={subItemNameChinese} onChange={this.subItemNameChineseOnChange} />
                                                                    </TabPane>
                                                                    :
                                                                    null
                                                            }

                                                            {/* Chinese Traditional */}
                                                            {
                                                                this.isLanguageIdActive(3)
                                                                    ?
                                                                    <TabPane tab='繁體中文' key='3'>
                                                                        <Input className='fnbadditionalitemmodal-input' value={subItemNameChineseTraditional} onChange={this.subItemNameChineseTraditionalOnChange} />
                                                                    </TabPane>
                                                                    :
                                                                    null
                                                            }

                                                            {/* Thai */}
                                                            {
                                                                this.isLanguageIdActive(4)
                                                                    ?
                                                                    <TabPane tab='ไทย' key='4'>
                                                                        <Input className='fnbadditionalitemmodal-input' value={subItemNameThai} onChange={this.subItemNameThaiOnChange} />
                                                                    </TabPane>
                                                                    :
                                                                    null
                                                            }

                                                            {/* Japanese */}
                                                            {
                                                                this.isLanguageIdActive(5)
                                                                    ?
                                                                    <TabPane tab='日本' key='5'>
                                                                        <Input className='fnbadditionalitemmodal-input' value={subItemNameJapanese} onChange={this.subItemNameJapaneseOnChange} />
                                                                    </TabPane>
                                                                    :
                                                                    null
                                                            }

                                                            {/* Vietnamese */}
                                                            {
                                                                this.isLanguageIdActive(6)
                                                                    ?
                                                                    <TabPane tab='Vietnamese' key='6'>
                                                                        <Input className='fnbadditionalitemmodal-input' value={subItemNameVietnamese} onChange={this.subItemNameVietnameseOnChange} />
                                                                    </TabPane>
                                                                    :
                                                                    null
                                                            }
                                                        </Tabs>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Row>
                                                    <Col span={8} className='fnbadditionalitemmodal-col-label'>
                                                        <Text className='fnbadditionalitemmodal-text-label'>Price<Text className='fnbadditionalitemmodal-text-label-mandatory'>*</Text></Text>
                                                    </Col>
                                                    <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                        <InputNumber
                                                            className='fnbadditionalitemmodal-inputnumber'
                                                            value={price}
                                                            min={0}
                                                            onChange={this.priceOnChange}
                                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                        /> &nbsp;&nbsp;
                                                        <Text className='fnbadditionalitemmodal-text-currency'>
                                                            {webSettting ? webSettting.currencyCode : 'No Currency'}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={24} className='fnbadditionalitemmodal-col'>
                                                <Row>
                                                    <Col span={8} />
                                                    <Col span={16} className='fnbadditionalitemmodal-col-input'>
                                                        <Button type='primary' disabled={addOrUpdateItemDetailDisable} className='fnbadditionalitemmodal-button-subitem' onClick={this.createOrUpdateFnbAdditionalItemDetailOnClick}>{itemDetailTextButton}</Button>
                                                        <Button className='fnbadditionalitemmodal-button-subitem' onClick={this.cancelFnbAdditionalItemDetailOnClick}>Cancel</Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} className='fnbadditionalitemmodal-col-button'>
                                        <Button disabled={addOrUpdateItemDisable} type='primary' className='fnbadditionalitemmodal-button' onClick={this.createOrUpdateFnbAdditionalItemOnClick}>{itemTextButton}</Button>
                                    </Col>
                                </Row>
                            </Spin >
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default FnbAdditionalItemModalPage;